// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"463":"443c33e7","587":"67e5416f","783":"8fa61562","809":"30846370","845":"9e9f8c18","897":"6a04e9be"}[chunkId] + ".chunk.css";
};